import React from 'react';

/**
 * CpscPill — CHA-230. Status-tone badge extracted from CpscSettings (was a file-local `Pill`) into a
 * shared module so the tone→class mapping lives in one place. Distinct from the rounded-full badge in
 * CpscBadges (that one drives the Production dashboard cells); this is the small square settings pill.
 * CHA-278 — Carbon pass: bordered mono status chip (radius 0, Plex Mono, carbon severity tokens).
 */
export const CPSC_PILL_TONE = {
  green: 'text-carbon-green-50 border-carbon-green-50 bg-carbon-green-10',
  amber: 'text-carbon-orange-70 border-carbon-orange-40 bg-carbon-white',
  red: 'text-carbon-red-60 border-carbon-red-60 bg-carbon-white',
  slate: 'text-carbon-gray-70 border-carbon-gray-30',
};

export default function CpscPill({ tone = 'slate', icon: Icon, children }) {
  return (
    <span className={`inline-flex items-center gap-1 font-plex-mono text-[10px] uppercase tracking-[0.06em] px-1.5 py-0.5 border ${CPSC_PILL_TONE[tone]}`}>
      {Icon ? <Icon size={11} /> : null}{children}
    </span>
  );
}
